import { useRef, useState } from 'react'

// Renders text on a single truncated line (ellipsis on overflow). On hover, if the
// text is actually clipped (scrollWidth > clientWidth), shows a styled popover with
// the full text. The width constraint must come from `className` (e.g. "max-w-[16rem]")
// since truncation needs a bounded width.
export default function TruncatedCell({ text, className = '', align = 'left' }) {
  const ref = useRef(null)
  const [overflow, setOverflow] = useState(false)
  const [hover, setHover] = useState(false)
  const display = (text == null || text === '') ? '—' : String(text)

  const onEnter = () => {
    const el = ref.current
    if (el) setOverflow(el.scrollWidth > el.clientWidth)
    setHover(true)
  }

  return (
    <span
      className="relative block min-w-0"
      onMouseEnter={onEnter}
      onMouseLeave={() => { setHover(false); setOverflow(false) }}
    >
      <span ref={ref} className={`block truncate ${className}`}>{display}</span>
      {hover && overflow && (
        <span
          className={`absolute z-30 bottom-full mb-1 ${align === 'right' ? 'right-0' : 'left-0'} max-w-xs whitespace-normal break-words bg-gray-900 text-white text-xs rounded px-2 py-1 shadow-lg pointer-events-none`}
        >
          {display}
        </span>
      )}
    </span>
  )
}
